<script>
  import jQuery from "jquery";
  import { onDestroy, onMount } from "svelte";
  import Notifications, {
    addNotification,
    closeAllNotifications,
  } from "./Notifications";

  export let notifications = [];

  let progressId;
  let notificationId;

  function normalizeNotificationType({ type }) {
    switch (type) {
      case "notice":
      case "success":
        return "success";
      case "alert":
      case "error":
        return "error";
      case "warning":
        return "warning";
      default:
        return "info";
    }
  }

  onMount(() => {
    initialize();
  });

  function handleMessage({ detail }) {
    const { message } = detail;
    const { id, type, title, body, group, url, duration } = message;
    const notificationType = normalizeNotificationType(message);
    addNotification({
      id,
      title: title || notificationType,
      group: group || "message",
      type: notificationType,
      description: body,
      duration: duration || 10000,
      url,
    });
  }

  function handleProgress({ detail }) {
    const { message } = detail;
    const { id, title, type, body, group, progress, url, duration } = message;
    let notificationProgress = parseInt(progress, 10);
    let notificationTitle = `${title || group || "Progress"} (${
      notificationProgress || 0
    }%)`;

    addNotification({
      id,
      title: notificationTitle,
      group: group || "progress",
      type: "info",
      description: body,
      progress,
      duration: duration || 15000,
      url,
    });
  }

  // function destroy() {
  //   jQuery("body").off("tc-progress", handleProgress);
  //   jQuery("body").off("tc-message", handleMessage);
  // }

  function initialize() {
    // jQuery("body").on("tc-progress", handleProgress);
    // jQuery("body").on("tc-message", handleMessage);

    notifications.forEach(({ type, description, duration }) => {
      addNotification({
        type: normalizeNotificationType({ type }),
        description,
        duration: duration || 10000,
      });
    });

    let flashMessage = sessionStorage.getItem("tcFlashMessage");

    if (flashMessage && flashMessage != "") {
      addNotification({
        type: "error",
        description: flashMessage,
        duration: 60000,
      });
      sessionStorage.removeItem("tcFlashMessage");
    }
  }
</script>

<Notifications topoffset="65" />

<svelte:body on:tc-progress={handleProgress} on:tc-message={handleMessage} />
